// Copyright (c) Microsoft. All rights reserved.

import { useMsal } from '@azure/msal-react';
import { Button, Image, Title3 } from '@fluentui/react-components';
import React from 'react';
import signInLogo from '../../ms-symbollockup_signin_light.svg';
import { useSharedClasses } from '../../styles';
import { getErrorDetails } from '../utils/TextUtils';
// import { InteractionStatus } from "@azure/msal-browser";

export const Login: React.FC = () => {
    const { instance } = useMsal();
    // const isAuthenticated = useIsAuthenticated();
    const classes = useSharedClasses();

    // useEffect(() => {
    //     if (!isAuthenticated && inProgress === InteractionStatus.None) {
    //         instance.loginRedirect().catch((e: unknown) => {
    //             console.log(`Error signing in: ${getErrorDetails(e)}`);
    //         });
    //     }
    // }, [isAuthenticated, inProgress, instance]);

    return (
        <div className={classes.informativeView}>
            <Title3>Login with your Vibracoustic Account</Title3>
            <Button
                style={{ padding: 0 }}
                appearance="transparent"
                onClick={() => {
                    instance.loginRedirect().catch((e: unknown) => {
                        alert(`Error signing in: ${getErrorDetails(e)}`);
                    });
                }}
                data-testid="signinButton"
            >
                <Image src={signInLogo} />
            </Button>
        </div>
    );
};
